import type { InputHTMLAttributes } from "react";
import { cn } from "../lib/cn.ts";

export type InputProps = InputHTMLAttributes<HTMLInputElement>;

export function Input({ className, ...props }: InputProps) {
  return (
    <input
      className={cn(
        "h-9 w-full rounded-[var(--sf-radius)] border border-[var(--sf-border-strong)]",
        "bg-[var(--sf-surface)] px-2.5 text-[13.5px] text-[var(--sf-text)] font-[inherit]",
        "outline-none transition-colors",
        "placeholder:text-[var(--sf-text-faint)]",
        "focus:border-[var(--sf-primary)] focus:ring-2 focus:ring-[var(--sf-primary-50)]",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    />
  );
}
